import { render, staticRenderFns } from "./crsInfo.vue?vue&type=template&id=86572a50"
import script from "./crsInfo.vue?vue&type=script&lang=js"
export * from "./crsInfo.vue?vue&type=script&lang=js"
import style0 from "./crsInfo.vue?vue&type=style&index=0&id=86572a50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports